import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import "./JournalContent.css";
import { demoResources, demoOperations } from "../Resources/demoData";
import { mockOrderData } from "../Diagram/mockData";

function JournalContent() {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [openRows, setOpenRows] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [dataSource, setDataSource] = useState('demo');
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const itemsPerPage = 10;

    const transformDemoData = () => {
        try {
            const historyFromResources = (demoResources || []).map((resource, index) => ({
                id: `res_${index + 1}`,
                agentId: resource.name || `agent_${index + 1}`,
                parameterBody: resource.typeAgent || "Мониторинг ресурса",
                parameterId: resource.id?.toString() || `param_${index + 1}`,
                parameterStatus: getRandomStatus(),
                parentParameterId: resource.group?.toString() || "root",
                timeStart: generateRandomDate(-30, -1),
                timeEnd: generateRandomDate(-1, 0),
                timetableBody: getRandomTimetable(),
                transferDate: generateRandomDate(-1, 0),
                transferStatus: getRandomTransferStatus()
            }));

            const historyFromOperations = (demoOperations || []).map((operation, index) => ({
                id: `op_${index + 1}`,
                agentId: operation.name || `operation_${index + 1}`,
                parameterBody: operation.description || "Выполнение операции",
                parameterId: operation.id?.toString() || `op_param_${index + 1}`,
                parameterStatus: mapOperationStatus(operation.status),
                parentParameterId: operation.orderId?.toString() || "operation_root",
                timeStart: operation.startDate || generateRandomDate(-7, -1),
                timeEnd: operation.endDate || generateRandomDate(-1, 0),
                timetableBody: "По расписанию выполнения",
                transferDate: operation.endDate || generateRandomDate(-1, 0),
                transferStatus: operation.status === 2 ? "success" : "pending"
            }));

            const historyFromOrders = (mockOrderData || []).map((order, index) => ({
                id: `order_${index + 1}`,
                agentId: `ORDER_${order.id || index + 1}`,
                parameterBody: order.title || "Обработка заказа",
                parameterId: order.id?.toString() || `order_param_${index + 1}`,
                parameterStatus: mapOrderStatus(order.status),
                parentParameterId: "orders_system",
                timeStart: order.createdAt || generateRandomDate(-15, -1),
                timeEnd: order.updatedAt || generateRandomDate(-1, 0),
                timetableBody: "Ежедневная обработка",
                transferDate: order.updatedAt || generateRandomDate(-1, 0),
                transferStatus: mapOrderTransferStatus(order.status)
            }));

            return [
                ...historyFromResources,
                ...historyFromOperations,
                ...historyFromOrders
            ].sort((a, b) => new Date(b.transferDate) - new Date(a.transferDate));

        } catch (error) {
            console.error("Ошибка при преобразовании демо данных:", error);
            return generateFallbackDemoData();
        }
    };

    const getRandomStatus = () => {
        const statuses = ["активный", "предупреждение", "ошибка", "завершен"];
        return statuses[Math.floor(Math.random() * statuses.length)];
    };

    const getRandomTransferStatus = () => {
        const statuses = ["успешно", "в ожидании", "неудачно", "в процессе"];
        return statuses[Math.floor(Math.random() * statuses.length)];
    };

    const getRandomTimetable = () => {
        const timetables = [
            "Каждые 5 минут",
            "Каждый час",
            "Каждые 2 часа",
            "Ежедневно в 9:00",
            "По требованию",
            "Непрерывный мониторинг",
            "По расписанию"
        ];
        return timetables[Math.floor(Math.random() * timetables.length)];
    };

    const generateRandomDate = (daysFrom, daysTo) => {
        const date = new Date();
        const offset = daysFrom + Math.random() * (daysTo - daysFrom);
        date.setDate(date.getDate() + offset);
        date.setHours(Math.floor(Math.random() * 24));
        date.setMinutes(Math.floor(Math.random() * 60));
        return date.toISOString();
    };

    const mapOperationStatus = (status) => {
        const statusMap = {
            1: "активный",
            2: "завершен",
            3: "в ожидании",
            4: "ошибка",
            5: "предупреждение",
            6: "активный"
        };
        return statusMap[status] || "активный";
    };

    const mapOrderStatus = (status) => {
        const statusMap = {
            1: "активный",
            2: "завершен",
            3: "в ожидании",
            4: "ошибка",
            5: "предупреждение",
            6: "активный",
            7: "в ожидании",
            10: "активный"
        };
        return statusMap[status] || "активный";
    };

    const mapOrderTransferStatus = (status) => {
        const statusMap = {
            1: "в процессе",
            2: "успешно",
            3: "в ожидании",
            4: "неудачно",
            5: "в ожидании",
            6: "в процессе",
            7: "в ожидании",
            10: "в процессе"
        };
        return statusMap[status] || "в ожидании";
    };

    const generateFallbackDemoData = () => {
        return Array.from({ length: 25 }, (_, i) => ({
            id: i + 1,
            agentId: `AGENT_${String(i + 1).padStart(3, '0')}`,
            parameterBody: `Параметр мониторинга ${i + 1}`,
            parameterId: `PARAM_${String(i + 1).padStart(3, '0')}`,
            parameterStatus: i % 4 === 0 ? "active" : i % 4 === 1 ? "warning" : i % 4 === 2 ? "error" : "completed",
            parentParameterId: i % 3 === 0 ? "SYSTEM_A" : i % 3 === 1 ? "SYSTEM_B" : "SYSTEM_C",
            timeStart: generateRandomDate(-30, -10),
            timeEnd: generateRandomDate(-9, -1),
            timetableBody: i % 5 === 0 ? "Каждые 5 минут" : i % 5 === 1 ? "Каждый час" : i % 5 === 2 ? "Ежедневно" : i % 5 === 3 ? "По требованию" : "Непрерывно",
            transferDate: generateRandomDate(-2, 0),
            transferStatus: i % 3 === 0 ? "success" : i % 3 === 1 ? "pending" : "failed"
        }));
    };

    const demoData = useMemo(() => transformDemoData(), []);

    const fetchData = async () => {
        setLoading(true);
        setError(null);

        try {
            if (dataSource === 'api') {
                const response = await axios.get(
                    'https://monitor.dev.masiot.dmsolution.ru/api/v1/history/',
                    {
                        timeout: 5000,
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        }
                    }
                );

                if (response.data && Array.isArray(response.data)) {
                    setData(response.data);
                } else {
                    throw new Error("Некорректный формат данных от API");
                }
            } else {
                setData(demoData);
            }
        } catch (error) {
            console.error("Ошибка при загрузке данных:", error);
            setError(
                dataSource === 'api'
                    ? `Не удалось подключиться к серверу. Показаны демо данные. (${error.message})`
                    : "Используются демо данные"
            );
            setData(demoData);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!searchTerm.trim()) {
            setFilteredData(data);
            return;
        }

        const filtered = data.filter(item =>
            item.agentId?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.parameterBody?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.parameterId?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.parameterStatus?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.transferStatus?.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredData(filtered);
    }, [data, searchTerm]);

    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });

        const sortedData = [...filteredData].sort((a, b) => {
            if (a[key] < b[key]) {
                return direction === 'ascending' ? -1 : 1;
            }
            if (a[key] > b[key]) {
                return direction === 'ascending' ? 1 : -1;
            }
            return 0;
        });
        setFilteredData(sortedData);
    };

    const toggleRow = (index) => {
        setOpenRows(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    const stats = useMemo(() => ({
        total: data.length,
        active: data.filter(item => item.parameterStatus === 'active').length,
        errors: data.filter(item =>
            item.parameterStatus === 'error' ||
            item.transferStatus === 'failed'
        ).length,
        today: data.filter(item => {
            try {
                const date = new Date(item.transferDate);
                const today = new Date();
                return date.toDateString() === today.toDateString();
            } catch {
                return false;
            }
        }).length,
        success: data.filter(item => item.transferStatus === 'success').length
    }), [data]);

    const paginatedData = useMemo(() => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        return filteredData.slice(startIndex, startIndex + itemsPerPage);
    }, [filteredData, currentPage]);

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    useEffect(() => {
        fetchData();

        let interval;
        if (dataSource === 'api') {
            interval = setInterval(fetchData, 30000);
        }
        return () => clearInterval(interval);
    }, [dataSource]);

    const formatDate = (dateString) => {
        if (!dateString) return 'Не указано';
        try {
            const date = new Date(dateString);
            return date.toLocaleString('ru-RU', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        } catch {
            return 'Некорректная дата';
        }
    };

    const getStatusClass = (status) => {
        const statusLower = status?.toLowerCase();

        if (statusLower === "активный" || statusLower === "завершен" || statusLower === "успешно") {
            return "status-success";
        } else if (statusLower === "предупреждение" || statusLower === "в ожидании") {
            return "status-warning";
        } else if (statusLower === "ошибка" || statusLower === "неудачно") {
            return "status-error";
        } else if (statusLower === "в процессе") {
            return "status-info";
        } else {
            return "status-info";
        }
    };

    const handleDataSourceChange = (source) => {
        setDataSource(source);
        setCurrentPage(1);
        setSearchTerm("");
        setOpenRows({});
    };

    if (loading && data.length === 0) {
        return (
            <div className="journal-container">
                <div className="loading-container">
                    <div className="spinner"></div>
                    <h3>Загрузка данных...</h3>
                </div>
            </div>
        );
    }

    return (
        <div className="journal-container">
            <div className="content-wrapper">
                <div className="page-header">
                    <h1 className="page-title">📋 Журнал истории операций</h1>
                    <p className="page-subtitle">Мониторинг и анализ всех системных событий</p>
                </div>

                <div className="filter-card">
                    <div className="control-panel">
                        <div className="data-source-selector">
                            <div className="source-buttons">
                                <button
                                    className={`source-btn ${dataSource === 'demo' ? 'active' : ''}`}
                                    onClick={() => handleDataSourceChange('demo')}
                                    style={{
                                        background: dataSource === 'demo' ? '#ff7675' : '#f1f3f4',
                                        color: dataSource === 'demo' ? 'white' : '#5f6368'
                                    }}
                                >
                                    <span className="source-icon">📊</span>
                                    ДЕМО ДАННЫЕ
                                    {dataSource === 'demo' && <span className="active-badge">активно</span>}
                                </button>
                                <button
                                    className={`source-btn ${dataSource === 'api' ? 'active' : ''}`}
                                    onClick={() => handleDataSourceChange('api')}
                                    style={{
                                        background: dataSource === 'api' ? '#74b9ff' : '#f1f3f4',
                                        color: dataSource === 'api' ? 'white' : '#5f6368'
                                    }}
                                >
                                    <span className="source-icon">🔄</span>
                                    API (реальные данные)
                                    {dataSource === 'api' && <span className="active-badge">активно</span>}
                                </button>
                            </div>
                        </div>

                        <div className="search-container">
                            <span className="search-icon">🔍</span>
                            <input
                                type="text"
                                placeholder="Поиск по Agent ID, параметру, статусу..."
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setCurrentPage(1);
                                }}
                                className="search-input"
                            />
                            {searchTerm && (
                                <button
                                    className="clear-search"
                                    onClick={() => setSearchTerm("")}
                                >
                                    ✕
                                </button>
                            )}
                        </div>

                        <div className="stats-preview">
                            <div className="stat-preview">
                                <span className="stat-label">Всего записей:</span>
                                <span className="stat-value">{stats.total}</span>
                            </div>
                            <div className="stat-preview">
                                <span className="stat-label">Активные:</span>
                                <span className="stat-value" style={{color: '#2ecc71'}}>{stats.active}</span>
                            </div>
                            <div className="stat-preview">
                                <span className="stat-label">Успешных:</span>
                                <span className="stat-value" style={{color: '#3498db'}}>{stats.success}</span>
                            </div>
                            <div className="stat-preview">
                                <span className="stat-label">Ошибки:</span>
                                <span className="stat-value" style={{color: '#e74c3c'}}>{stats.errors}</span>
                            </div>
                        </div>
                    </div>

                    <div className="data-source-indicator">
                        <div className={`indicator-dot ${dataSource === 'demo' ? 'demo' : 'api'}`}></div>
                        <span>
                            Режим: <strong>{dataSource === 'demo' ? 'ДЕМО-ДАННЫЕ (из файлов статистики)' : 'API (реальные данные)'}</strong>
                        </span>
                        <button className="refresh-btn" onClick={fetchData}>
                            <span>🔄</span> Обновить
                        </button>
                    </div>

                    {error && (
                        <div className="error-message">
                            ⚠️ {error}
                        </div>
                    )}
                </div>

                <div className="table-wrapper">
                    <div className="table-header">
                        <h3>История операций ({filteredData.length} записей)</h3>
                        <div className="table-actions">
                            <span className="records-info">
                                Показано {paginatedData.length} из {filteredData.length}
                            </span>
                            <div className="view-options">
                                <button className="view-option active">Таблица</button>
                                <button className="view-option">Карточки</button>
                            </div>
                        </div>
                    </div>

                    <table className="history-table">
                        <thead>
                        <tr>
                            <th></th>
                            <th onClick={() => requestSort('agentId')}>
                                Agent ID {sortConfig.key === 'agentId' && (sortConfig.direction === 'ascending' ? '↑' : '↓')}
                            </th>
                            <th onClick={() => requestSort('parameterBody')}>
                                Параметр {sortConfig.key === 'parameterBody' && (sortConfig.direction === 'ascending' ? '↑' : '↓')}
                            </th>
                            <th onClick={() => requestSort('parameterStatus')}>
                                Статус {sortConfig.key === 'parameterStatus' && (sortConfig.direction === 'ascending' ? '↑' : '↓')}
                            </th>
                            <th onClick={() => requestSort('timeStart')}>
                                Начало {sortConfig.key === 'timeStart' && (sortConfig.direction === 'ascending' ? '↑' : '↓')}
                            </th>
                            <th onClick={() => requestSort('transferStatus')}>
                                Передача {sortConfig.key === 'transferStatus' && (sortConfig.direction === 'ascending' ? '↑' : '↓')}
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {paginatedData.map((item, index) => (
                            <React.Fragment key={item.id || index}>
                                <tr className={openRows[index] ? 'selected' : ''}>
                                    <td>
                                        <button
                                            onClick={() => toggleRow(index)}
                                            className="expand-btn"
                                            title={openRows[index] ? "Скрыть детали" : "Показать детали"}
                                        >
                                            {openRows[index] ? "−" : "+"}
                                        </button>
                                    </td>
                                    <td>
                                        <div className="agent-cell">
                                            <span className="agent-id">{item.agentId}</span>
                                            <span className="agent-type">
                                                    {item.agentId.includes('ORDER') ? 'Заказ' :
                                                        item.agentId.includes('AGENT') ? 'Агент' : 'Ресурс'}
                                                </span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="parameter-cell">
                                            <div className="parameter-name">{item.parameterBody}</div>
                                            <div className="parameter-id">ID: {item.parameterId}</div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="status-cell">
                                                <span className={`status-badge ${getStatusClass(item.parameterStatus)}`}>
                                                    {item.parameterStatus}
                                                </span>
                                            {item.parentParameterId && item.parentParameterId !== 'root' && (
                                                <div className="parent-id">Родитель: {item.parentParameterId}</div>
                                            )}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="date-cell">
                                            <div className="date-value">{formatDate(item.timeStart)}</div>
                                            <div className="date-duration">
                                                Длит: {(() => {
                                                try {
                                                    const start = new Date(item.timeStart);
                                                    const end = new Date(item.timeEnd);
                                                    const hours = Math.round((end - start) / (1000 * 60 * 60));
                                                    return `${hours} ч`;
                                                } catch {
                                                    return 'N/A';
                                                }
                                            })()}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="transfer-cell">
                                                <span className={`status-badge ${getStatusClass(item.transferStatus)}`}>
                                                    {item.transferStatus}
                                                </span>
                                            <div className="transfer-date">{formatDate(item.transferDate)}</div>
                                        </div>
                                    </td>
                                </tr>

                                {openRows[index] && (
                                    <tr className="expanded-content">
                                        <td colSpan="6">
                                            <div className="details-grid">
                                                <div className="detail-section">
                                                    <h4>Основная информация</h4>
                                                    <div className="detail-grid">
                                                        <div className="detail-item">
                                                            <span className="detail-label">Agent ID</span>
                                                            <span className="detail-value">{item.agentId}</span>
                                                        </div>
                                                        <div className="detail-item">
                                                            <span className="detail-label">Тип объекта</span>
                                                            <span className="detail-value">
                                                                    {item.agentId.includes('ORDER') ? 'Заказ' :
                                                                        item.agentId.includes('AGENT') ? 'Агент' : 'Системный ресурс'}
                                                                </span>
                                                        </div>
                                                        <div className="detail-item">
                                                            <span className="detail-label">Источник данных</span>
                                                            <span className="detail-value" style={{
                                                                color: dataSource === 'demo' ? '#ff7675' : '#74b9ff',
                                                                fontWeight: 'bold'
                                                            }}>
                                                                    {dataSource === 'demo' ? 'ДЕМО (файлы статистики)' : 'API (реальные)'}
                                                                </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="detail-section">
                                                    <h4>Параметры</h4>
                                                    <div className="detail-grid">
                                                        <div className="detail-item">
                                                            <span className="detail-label">Название параметра</span>
                                                            <span className="detail-value">{item.parameterBody}</span>
                                                        </div>
                                                        <div className="detail-item">
                                                            <span className="detail-label">ID параметра</span>
                                                            <span className="detail-value">{item.parameterId}</span>
                                                        </div>
                                                        <div className="detail-item">
                                                            <span className="detail-label">Родительский ID</span>
                                                            <span className="detail-value">{item.parentParameterId || 'Не указан'}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="detail-section">
                                                    <h4>Временные параметры</h4>
                                                    <div className="detail-grid">
                                                        <div className="detail-item">
                                                            <span className="detail-label">Время начала</span>
                                                            <span className="detail-value">{formatDate(item.timeStart)}</span>
                                                        </div>
                                                        <div className="detail-item">
                                                            <span className="detail-label">Время окончания</span>
                                                            <span className="detail-value">{formatDate(item.timeEnd)}</span>
                                                        </div>
                                                        <div className="detail-item">
                                                            <span className="detail-label">Расписание</span>
                                                            <span className="detail-value">{item.timetableBody}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="detail-section">
                                                    <h4>Статусы</h4>
                                                    <div className="detail-grid">
                                                        <div className="detail-item">
                                                            <span className="detail-label">Статус параметра</span>
                                                            <span className={`detail-value ${getStatusClass(item.parameterStatus)}`}>
                                                                    {item.parameterStatus}
                                                                </span>
                                                        </div>
                                                        <div className="detail-item">
                                                            <span className="detail-label">Статус передачи</span>
                                                            <span className={`detail-value ${getStatusClass(item.transferStatus)}`}>
                                                                    {item.transferStatus}
                                                                </span>
                                                        </div>
                                                        <div className="detail-item">
                                                            <span className="detail-label">Дата передачи</span>
                                                            <span className="detail-value">{formatDate(item.transferDate)}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))}
                        </tbody>
                    </table>

                    {totalPages > 1 && (
                        <div className="pagination">
                            <button
                                className="pagination-button"
                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                disabled={currentPage === 1}
                            >
                                ← Предыдущая
                            </button>

                            <div className="page-numbers">
                                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                                    let pageNum;
                                    if (totalPages <= 5) {
                                        pageNum = i + 1;
                                    } else if (currentPage <= 3) {
                                        pageNum = i + 1;
                                    } else if (currentPage >= totalPages - 2) {
                                        pageNum = totalPages - 4 + i;
                                    } else {
                                        pageNum = currentPage - 2 + i;
                                    }

                                    return (
                                        <button
                                            key={i}
                                            className={`pagination-button ${currentPage === pageNum ? 'active' : ''}`}
                                            onClick={() => setCurrentPage(pageNum)}
                                        >
                                            {pageNum}
                                        </button>
                                    );
                                })}
                            </div>

                            <button
                                className="pagination-button"
                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                disabled={currentPage === totalPages}
                            >
                                Следующая →
                            </button>
                        </div>
                    )}

                    {paginatedData.length === 0 && (
                        <div className="empty-state">
                            <div className="empty-icon">📭</div>
                            <h3>Нет данных для отображения</h3>
                            <p>Попробуйте изменить параметры поиска или переключить источник данных</p>
                        </div>
                    )}
                </div>

                <div className="footer-info">
                    <p>
                        💡 Данные обновлены: {new Date().toLocaleString('ru-RU')} |
                        Источник: <strong>{dataSource === 'demo' ? 'Демо данные из файлов статистики' : 'API сервер'}</strong> |
                        Всего записей в системе: <strong>{data.length}</strong>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default JournalContent;